module.exports = __webpack_public_path__ + "img/5c6fd434ba3fa5edf0cc88b6e571b97f.png";